module.exports = __webpack_public_path__ + "static/media/title_bg@2x.94677e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/location/title_bg@2x.png
// module id = 87
// module chunks = 0